
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Route } from 'vue-router'
import { Dictionary } from 'vue-router/types/router'
import SimpleTable from '@/components/busi/table/simple-table.vue'
import { UserModule } from '@/store/modules/user'
import { RightModule } from '@/store/modules/right'
import { isValidUsername } from '@/utils/validate'
import LangSelect from '@/components/LangSelect/index.vue'
import SocialSign from './components/SocialSignin.vue'
import VueImgVerify from './vue-img-verify.vue'
import md5 from 'md5'
import dayjs from 'dayjs'
import { userSubDeadlineTips, userDeadlineTips } from '@/api/common/common'
import { MenuModule } from '@/store/modules/menu'
import { LocalStorage } from '@/utils/storage'
import { PermissionModule } from '@/store/modules/permission'
import router from '@/router'
import { checkPermission } from '@/utils/permission'

@Component({
  name: 'Login',
  components: {
    LangSelect,
    SimpleTable,
    SocialSign,
    VueImgVerify
  }
})
export default class extends Vue {
  private loginType = {
    placeholder: '请输入账号',
    button: '手机号登录',
    placeholderPhone: '请输入手机号',
    buttonPhone: '手机号登录',
    placeholderAccount: '请输入账号',
    buttonAccount: '账号登录'
  }

  get userName () {
    return UserModule.name
  }

  private logo = require('../../assets/statics/pics/favicon.png')

  private bgImg = require('../../assets/statics/pics/bg.png')

  private imgCode = ''

  private broswerSrc = require('../../assets/statics/pics/browser.png')

  private columns = [
    {
      prop: 'userAccount',
      label: '账号'
    },
    {
      prop: 'userName',
      label: '用户名称'
    },
    {
      prop: 'proTypeNames',
      label: '代理类型'
    },
    {
      prop: 'proLevelName',
      label: '代理级别'
    },
    {
      prop: 'phone',
      label: '联系号码'
    },
    {
      prop: 'deadline',
      label: '合同截止时间',
      format: 'date'
    }
  ]

  private dialogVisible = !1

  private tableData = {
    list: [],
    totalCount: 0
  }

  private pagination = {
    pageSize: 10,
    currentPage: 1
  }

  private validateUsername = (rule: any, value: string, callback: Function) => {
    if (!isValidUsername(value)) {
      callback(new Error('请输入正确的用户名'))
    } else {
      callback()
    }
  }

  private validatePassword = (rule: any, value: string, callback: Function) => {
    if (value.length < 6) {
      callback(new Error('密码不能少于6位数'))
    } else {
      callback()
    }
  }

  private validateCode (rule: any, value: string, callback: Function) {
    if (!this.loginForm.code || this.imgCode !== this.loginForm.code.toLowerCase()) {
      callback(new Error('验证码错误'))
      this.$message.error('验证码错误')
    } else {
      callback()
    }
  }

  private loginForm: any = {
    username: '',
    password: '',
    code: ''
  }

  private loginRules = {
    username: [{ validator: this.validateUsername, trigger: 'blur' }],
    password: [{ validator: this.validatePassword, trigger: 'blur' }],
    code: [{ validator: this.validateCode, trigger: 'blur' }]
  }

  // 点击图片获取验证码
  private getImgCode (code: any) {
    this.imgCode = code
  }

  private passwordType = 'password'
  private loading = false
  private showDialog = false
  private capsTooltip = false
  private redirect?: string
  private otherQuery: Dictionary<string> = {}

  @Watch('$route', { immediate: true })
  private onRouteChange (route: Route) {
    // TODO: remove the "as Dictionary<string>" hack after v4 release for vue-router
    // See https://github.com/vuejs/vue-router/pull/2050 for details
    const query = route.query as Dictionary<string>
    if (query) {
      this.redirect = query.redirect
      this.otherQuery = this.getOtherQuery(query)
    }
  }

  private loginChange () {
    if (this.loginType.button === '手机号登录') {
      this.loginType.placeholder = this.loginType.placeholderPhone
      this.loginType.button = this.loginType.buttonAccount
    } else {
      this.loginType.placeholder = this.loginType.placeholderAccount
      this.loginType.button = this.loginType.buttonPhone
    }
    this.loginForm.username = ''
    this.loginForm.password = ''
    this.loginForm.code = ''
  }

  mounted () {
    if (this.loginForm.username === '') {
      (this.$refs.username as any).focus()
    } else if (this.loginForm.password === '') {
      (this.$refs.password as any).focus()
    }
    document.onkeydown = () => {
      const _key = (window.event as any).keyCode
      if (_key === 13) {
        this.handleLogin()
      }
    }
  }

  private checkCapslock (e: KeyboardEvent) {
    const { key } = e
    this.capsTooltip = key !== null && key.length === 1 && (key >= 'A' && key <= 'Z')
  }

  private showPwd () {
    if (this.passwordType === 'password') {
      this.passwordType = ''
    } else {
      this.passwordType = 'password'
    }
    this.$nextTick(() => {
      (this.$refs.password as any).focus()
    })
  }

  private handleLogin () {
    if (this.loading) return
    (this.$refs.loginForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = !0
        const params = {
          userAccount: this.loginForm.username.trim(),
          pwd: md5(this.loginForm.password),
          loginType: this.loginType.button
        }
        await UserModule.Login(params).then(async () => {
          await RightModule.getRightByUserId(UserModule.rpcid).then(() => {
            // 初始化菜单权限
            PermissionModule.GenerateRoutes(RightModule.accessroutes)
            // 菜单权限加入到动态路由中
            if (!RightModule.accessroutes || (RightModule.accessroutes as any).length === 0) {
              this.$router.push({
                path: this.redirect || '/',
                query: this.otherQuery
              },
              () => {
                // do
                this.loading = !1
              })
              return
            }
            router.addRoutes(PermissionModule.dynamicRoutes)
            this.userDeadlineTips()
          }).catch(() => {
            RightModule.ResetAccessRoutes()
            UserModule.ResetToken()
          })
        }).catch(err => {
          this.$message(err)
          this.loading = !1
        })
      } else {
        this.loading = !1
        return false
      }
    })
  }

  private getOtherQuery (query: Dictionary<string>) {
    return Object.keys(query).reduce((acc, cur) => {
      if (cur !== 'redirect') {
        acc[cur] = query[cur]
      }
      return acc
    }, {} as Dictionary<string>)
  }

  private async userSubDeadlineTips () {
    if (checkPermission(['userSubDeadlineTips'])) {
      await userSubDeadlineTips({
        id: UserModule.id,
        ...this.pagination
      }).then((res: any) => {
        if (res.code === 10000) {
          if (res.object.totalCount > 0) {
            this.tableData = res.object
            this.dialogVisible = !0
          } else {
            this.dialogVisible = !1
            this.close()
          }
        }
      })
    } else {
      this.close()
    }
  }

  private async userDeadlineTips () {
    if (checkPermission(['userDeadlineTips'])) {
      await userDeadlineTips({
        id: UserModule.id
      }).then((res: any) => {
        if (res.code === 10000) {
          const result = res.object.deadline - new Date().getTime() - (24 * 60 * 60 * 1000 - 1)
          if (result < 86400 * 1000 * 3) {
            this.$alert(`${UserModule.name}您好，您的代理合同将于${dayjs(res.object.deadline).format('YYYY-MM-DD')}日代理到期，请尽快联系负责人进行续约，以免合同到期给您带来不便！谢谢！`, {
              confirmButtonText: '确定',
              callback: () => {
                this.userSubDeadlineTips()
              }
            })
          } else {
            this.userSubDeadlineTips()
          }
        }
      })
    } else {
      this.userSubDeadlineTips()
    }
  }

  private toProxyUser () {
    setTimeout(() => {
      MenuModule.updateMenuName('agentcenter')
      this.$router.push({
        name: 'agentUserManagement'
      },
      () => {
        // do
        this.loading = !1
      })
    }, 0.3 * 1000)
  }

  private close () {
    this.dialogVisible = !1
    // 默认打开第一个菜单
    const parent = LocalStorage.getObj(RightModule.KEYS.ROUTE)[0].children[0]
    setTimeout(() => {
      MenuModule.updateMenuName(parent.name)
      this.$router.push({
        name: parent.children[0].name,
        query: this.otherQuery
      },
      () => {
        // do
        this.loading = !1
      })
    }, 0.3 * 1000)
  }
}
